const query = {
  param(name: string, newValue?: string) {
    const params = new URLSearchParams(window.location.search)
    if (arguments.length === 1) {
      return params.get(name)
    } else {
      params.set(name, newValue!)
      const newParams = params.toString()
      const newUrl =
        window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + newParams.toString()
      window.location.href = newUrl
    }
  }
}

export function queryMagic(el: Node) {
  return query
}
